// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"639e2cc5","163":"57810b6b","453":"ca2ac4b1","459":"a6631306","533":"bf2ad72b","576":"f67ec8c1","871":"4eb73941","948":"2c78234c"}[chunkId] + ".chunk.js";
};